
import * as config from './config.json'
import { PipelineState } from './types';

export const LocalStorageKey = {
  requestId: 'appauth_current_authorization_request',
  authRequest: '_appauth_authorization_request',
  serviceConfig: '_appauth_authorization_service_configuration',
}

export const Page = {
  start: '/',
  deployment: '/deployment',
  merge: '/merge',
  authenticating: '/auth',
}

export const State = {
  pending: 'PENDING' as PipelineState,
  running: 'IN_PROGRESS' as PipelineState,
  completed: 'COMPLETED' as PipelineState,
  failed: 'FAILED' as PipelineState,
  successful: 'SUCCESSFUL' as PipelineState,
  notFound: 'NOT_FOUND' as PipelineState,
  stopped: 'STOPPED' as PipelineState
}

export const BitBucketAPI = {
  url: config.bitbucket.url,
  workspace: config.bitbucket.workspace + '/',
}

export const configRepository = config.bitbucket.config_repository;
export const configFile = '/' + config.bitbucket.config_file;
export const initBranch = config.bitbucket.config_default_branch


export const APIEndpoint = {
  user: 'user',
  pipelines: '/pipelines/',
  commits: '/commits/',
  tags: '/refs/tags/',
  head: '/refs/branches/',
  src: '/src/',
  pullRequests: '/pullrequests/',
  merge: '/merge',
  repositories: 'repositories/' + BitBucketAPI.workspace,
  diff: '/diffstat/',
  branchModel: '/branching-model/'
}

export const PartialResponse = {
  separator: ',',
  fields: 'fields=next',
  nameOfValues: 'values.name',
  targetHashOfValues: 'values.target.hash',
  hashOfCommit: 'values.target.commit.hash',
  stateOfPipeline: 'values.state',
  hashOfTarget: 'target.hash',
  hashOfMergeCommit: 'merge_commit.hash',
  idOfPullRequest: 'id',
  nameOfDevelopment: 'development.name',
  nameOfProduction: 'production.name'
}
export const Query = {
  prefix: '?',
  search: 'q=',
  and: '&',
  pagelen: 'pagelen=',
  sort: {
    createdOn: 'sort=-created_on',
    targetDate: 'sort=-target.date',
  },
  operators: {
    and: 'AND',
    or: 'OR'
  }
}
//
export const Tag = {
  release: 'release-',
  develop: '-dev',
  feature: 'WEASL'
}

export const Branch = {
  master: 'master',
  main: 'main',
  develop: 'develop'
}

export const releaseTag = 'release-';
export const developTag = '-dev';
export const latest = 'latest';

export const GetSuccess = 200;
export const PostSuccess = 201;
